export const CREATE_STORE = "createStore";
export const UPDATE_STORE = "updateStore";
export const UPDATE_STORE_ADMIN = "updateStoreAdmin";
export const UPDATE_STORE_SCHEDULE = "updateStoreSchedule";
export const GET_FAQS = "getFAQs";
export const CREATE_FAQ = "createFAQs";
export const UPDATE_FAQ = "updateFAQs";
export const DELETE_FAQ = "deleteFaq";
export const GET_TELEGRAM_USERS = "getTelegramUsers";
export const GET_STORE_USER_AUTH = "getStoreUserAuth";
export const GET_STORE_SCHEDULE = "getStoreSchedule";
export const UPDATE_STORE_IMAGE = "updateStoreImage";
export const FETCH_START_ADDRESS = "fetchStartAddress";
export const FETCH_END_ADRESS = "fetchEndAddress";
